import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { ActivatedRoute } from '@angular/router';
import { LogListService } from '../../features/loglist/services/loglist.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup } from '@angular/forms';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-logs-list',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatTabsModule,
    AgGridAngular,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './logs-list.component.html',
  styleUrl: './logs-list.component.scss',
})
export class LogsListComponent {
  columnDefs: any[] = [];

  logcolumnDef: any = [];

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public defaultLogColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public themeClass: string = 'ag-theme-quartz';
  public viewPortSize: boolean = false;
  stationaryId: any = null;

  public rowData : any[] = [];
  public LogrowData: any[] = [];

  dateRangeForm = new FormGroup({
    startDate: new FormControl<string | null>(null),
    endDate: new FormControl<string | null>(null),
  });

  public logTab: number = 0;
  canExpenseStationaryItems$ = this.permissionService.hasPermission(
      ModuleIds.StationaryItems,
      'Expense'
    );
    canExpenseLogsStationaryItems$ = this.permissionService.hasPermission(
      ModuleIds.StationaryItems,
      'Expense Logs'
    );

  constructor(
    private router: ActivatedRoute,
    private logListService: LogListService,
    private datePipe: DatePipe,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.checkViewportSize();
    this.router.paramMap.subscribe((params) => {
      this.stationaryId = params.get('id');
      if (this.stationaryId) {
        this.getStationaryPurchaseDetails(Number(this.stationaryId));
        this.getStationoryItemsLogs(Number(this.stationaryId), '', '');
      }
    });
  }

  onTabChange(index: number) {
    this.logTab = index;
    // console.log(this.logTab);
    if(this.logTab === 1){
      this.getStationoryItemsLogs(this.stationaryId, "", "");
    }
  }
  

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    return date ? date <= today : false;
  };

  onDateChange(event: any, type: 'start' | 'end') {
    if (event.value) {
      const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
      if (type === 'start') {
        this.dateRangeForm.patchValue({ startDate: formattedDate });
      } else {
        this.dateRangeForm.patchValue({ endDate: formattedDate });
      }
    }
  
    const startDate = this.dateRangeForm.value.startDate || '';
    const endDate = this.dateRangeForm.value.endDate || '';
  
    if (endDate) {
      this.getStationoryItemsLogs(this.stationaryId, startDate, endDate);
    }
  }
  

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.updateColumnDefs();
    this.updatelogColumnDefs();
  }

  updateColumnDefs(): void {
    this.columnDefs = [
      {
        headerName: 'Supplier Name',
        field: 'supplierName',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          return (
            params.value.charAt(0).toUpperCase() +
            params.value.slice(1).toLowerCase()
          );
        },
      },
      {
        headerName: 'Date',
        field: 'date',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Unit Price',
        field: 'unitPrice',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Sub Total',
        field: 'subTotal',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Tax',
        field: 'tax',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Total',
        field: 'total',
        flex: this.viewPortSize ? 1 : 0,
      },
    ];

    // this.columnDefs.push({
    //   field: 'action',
    //   headerName: 'Actions',
    //   floatingFilter: false,
    //   filter: false,
    //   flex: this.viewPortSize ? 1 : 0,
    //   cellRenderer: (params: any) => {
    //     const container = document.createElement('div');
    //     container.style.display = 'flex';
    //     container.style.alignItems = 'center';
    //     container.style.gap = '20px';

    //     const editIcon = document.createElement('img');
    //     editIcon.src = 'assets/images/icons/icon-edit.svg';
    //     editIcon.style.cursor = 'pointer';
    //     editIcon.setAttribute('data-action', 'edit');
    //     this.store
    //     .select(selectPermissions.hasPermission('45', Permission.Edit))
    //     .subscribe((canEdit) => {
    //       if (canEdit) {
    //         container.appendChild(editIcon);
    //       }
    //     });

    //     const deleteIcon = document.createElement('img');
    //     deleteIcon.src = 'assets/images/icons/icon-delete.svg';
    //     deleteIcon.style.cursor = 'pointer';
    //     deleteIcon.setAttribute('data-action', 'delete');
    //     this.store
    //       .select(selectPermissions.hasPermission('45', Permission.Delete))
    //       .subscribe((canDelete) => {
    //         if (canDelete) {
    //           container.appendChild(deleteIcon);
    //         }
    //       });

    //     return container;
    //   },
    // });
  }

  updatelogColumnDefs(): void {
    this.logcolumnDef = [
      {
        headerName: 'Date',
        field: 'date',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          return (
            params.value.charAt(0).toUpperCase() +
            params.value.slice(1).toLowerCase()
          );
        },
      },
      {
        headerName: 'Opening Stock',
        field: 'openingStock',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Closing Stock',
        field: 'closingStock',
        flex: this.viewPortSize ? 1 : 0,
      },
    ];

    // this.logcolumnDef.push({
    //   field: 'action',
    //   headerName: 'Actions',
    //   floatingFilter: false,
    //   filter: false,
    //   flex: this.viewPortSize ? 1 : 0,
    //   cellRenderer: (params: any) => {
    //     const container = document.createElement('div');
    //     container.style.display = 'flex';
    //     container.style.alignItems = 'center';
    //     container.style.gap = '20px';

    //     const editIcon = document.createElement('img');
    //     editIcon.src = 'assets/images/icons/icon-edit.svg';
    //     editIcon.style.cursor = 'pointer';
    //     editIcon.setAttribute('data-action', 'edit');
    //     this.store
    //     .select(selectPermissions.hasPermission('45', Permission.Edit))
    //     .subscribe((canEdit) => {
    //       if (canEdit) {
    //         container.appendChild(editIcon);
    //       }
    //     });

    //     const deleteIcon = document.createElement('img');
    //     deleteIcon.src = 'assets/images/icons/icon-delete.svg';
    //     deleteIcon.style.cursor = 'pointer';
    //     deleteIcon.setAttribute('data-action', 'delete');
    //     this.store
    //       .select(selectPermissions.hasPermission('45', Permission.Delete))
    //       .subscribe((canDelete) => {
    //         if (canDelete) {
    //           container.appendChild(deleteIcon);
    //         }
    //       });

    //     return container;
    //   },
    // });
  }

  getStationaryPurchaseDetails(id: any) {
    this.logListService.fetchStationaryPurchaseDetails(id).subscribe({
      next: (data) => {
        this.rowData = data.map((stationary: any) => ({
          id: stationary?.supplierId,
          supplierName: stationary?.supplierName || '--',
          // date: stationary?.date || '--',
          date:
            this.datePipe.transform(stationary?.date, 'dd/MM/yyyy', '+0000') ||
            '--',
          unitPrice: stationary?.unitPrice
            ? ` AED ${stationary.unitPrice}`
            : '--',
          subTotal: stationary?.subTotal ? `AED ${stationary.subTotal}` : '--',
          tax: stationary?.tax ? `AED ${stationary.tax}` : '--',
          total: stationary?.total ? `AED ${stationary.total}` : '--',
        }));
        
        this.paginationPageSizeSelector = PaginationHelper.getPaginationPageSizeOptions(this.rowData);
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

getStationoryItemsLogs(id: any, startDate: string, endDate: string) {
  const numericId = Number(id);

  this.logListService.fetchStationaryItemLogs(numericId, startDate, endDate).subscribe({
    next: (data) => {
      this.LogrowData = data.map((stationaryLog: any) => ({
        id: stationaryLog?.stationaryId,
        date: this.datePipe.transform(stationaryLog?.date, 'dd/MM/yyyy', '+0000') || '--',
        openingStock: stationaryLog?.openingStock || '--',
        closingStock: stationaryLog?.closingStock || '--',
      }));
      this.paginationPageSizeSelector = PaginationHelper.getPaginationPageSizeOptions(this.LogrowData);
    },
    error: (error) => {
      console.error(error, 'Error fetching logs');
    },
  });
}

}
